import type { StepLogDto } from '@nsb/core';
import { createContext } from 'react';
import { useApi } from '../../api.ts';
import { stepLogKey } from './stepLog.ts';

/** A step's log, read while its panel is open (`enabled`), from its own route (design study 31, slice 3). */
export const useStepLog = (projectId: string, stepId: string, enabled: boolean) =>
  useApi<StepLogDto>(stepLogKey(projectId, stepId), enabled ? `/projects/${projectId}/process/steps/${stepId}/log` : null);

/** Each task's count on its row, and pressing it shows only that task's entries in the step's log. */
export const LogCounts = createContext<{ counts: Map<string, number>; show: (taskId: string) => void } | null>(null);
